import type { FaireProductEntity } from "../../entity_types/product";

export const p_qgxrpxk26d: FaireProductEntity = {
  token: "p_qgxrpxk26d",
  type: "product",
  name: "Crew Sweatshirt - Cade",
  brandToken: "b_qba2f8n5gh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/72e8650d24e658e9a237ffd806f85abec3b25aad1c3b17a709b16a84f4377e47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/153b473f37d0f9b376b7e826f60e429d1ade0043d4267f1eba17a4955d76bf96.jpeg",
    "https://cdn.faire.com/fastly/72bc90e2fc0f11435bb36a977d144f9bd59b2a4e0d0a6effbb322fe0e89ae56a.jpeg",
    "https://cdn.faire.com/fastly/f494bfa54efb1c635a30d8c59e7a11cda310a87deb212a5cdbf679ad6ab265de.jpeg",
    "https://cdn.faire.com/fastly/7a260c4c900208f495c16bc81bf735e242614daaa242e9f76f3644d3816a65bd.jpeg",
    "https://cdn.faire.com/fastly/31edb2b0c04995ff4aa9b35b4d1c2f68cd9c0726be4435533df08dc03895e3c9.jpeg",
    "https://cdn.faire.com/fastly/ea388ef5abdd0ebfd229ec3017a05559466d97018d0162579ff75d0c90f54789.png",
    "https://cdn.faire.com/fastly/6687e578fd13cca589718e2a8f5824ab19740fe825853c648c2f8df98736d5c2.png",
  ],
  priceDollars: 22.87,
  description:
    "A classic, everyday crewneck. \n\nA treasured wardrobe basic, you'll reach for this super-soft sweatshirt again and again.\n\n * PREMIUM KNIT FABRIC - crew sweatshirts are made from ultra-soft material. Both lightweight and breathable, the premium fabric keeps you cool and comfortable. \n * BONUS FEATURES – Our crew sweatshirts feature a raglan sleeve, a crewneck and a classic, cozy fit. Available in sizes 0-3m through 5T. \n * TRENDY, HIGH-QUALITY DESIGNS – At Copper Pearl, we pride ourselves on making high quality products that always look great on babies and toddlers, moms, or in your nursery. Our crew sweatshirts are simple, modern, and sure to elevate your style.",
  tags: [],
  msrpDollars: 45.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:20.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
